CoffeeKup = require('./coffeekup.coffee')

class ValidationError extends Error
	name: "ValidationError"

	constructor: (@message) -> super(message)

class RequiredError extends ValidationError
	name: "RequiredError"

	constructor: -> super(trans.make TRANSLATIONS['strings.required'])

class UniqueError extends ValidationError
	name: "UniqueError"

	constructor: -> super(trans.make TRANSLATIONS['strings.unique'])

class Validation extends Backbone.Model
	@TYPES: {}
	@new: (cls) -> @TYPES[cls::type] = cls

	regex: /^.*$/

	inputAttrs: 'type':'text'
	defaults:
		message: ''

	initialize: ->
		if "#{@get('message')}".indexOf('{min}') > -1 or "#{@get('message')}".indexOf('{max}') > -1
			@useCustomMsg = true

	validate: (value) ->
		return if not value

		if not @regex.test(value)
			throw new ValidationError(@.get('message'))

		#Validate Length
		[min, max] = [parseInt(@get('minLength', 1), 10), parseInt(@get('maxLength', -1), 10)]
		if min or max
			message =
				if max < 0 then "This value must contain at least #{min} characters."
				else if min < 0 then "This value must contain at least #{min} characters."
				else "This value must be between #{min} and #{max} characters."
			if max < 0
				if value.length < min
					throw new ValidationError if @use_custom_msg then @get('message') else message
			else
				if not (min <= value.length <= max)
					throw new ValidationError if @use_custom_msg then @get('message') else message

Validation.new class extends Validation
	type: 'email'
	regex: /^\ *[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\ *$/
	inputAttrs:
		type: 'email'

Validation.new class extends Validation
	type: 'num'
	regex: /^[0-9]*$/
	inputAttrs:
		type: 'tel'

	validate: (value) ->
		super(value)

		return if not value

		[min, max] = [parseInt(@get('minValue', 0), 10), parseInt(@get('maxValue', -1), 10)]

		if not _.isNaN(min) and not _.isNaN(max) and not (min <= parseInt(value, 10) <= max)
			throw new ValidationError "This value must be between #{min} and #{max}."

Validation.new class extends Validation.TYPES['num']
	type: 'pos-neg-num'
	regex: /^-?[0-9]*$/
	inputAttrs:
		type: 'number'

Validation.new class extends Validation.TYPES['num']
	type: 'float'
	regex: /^[0-9]*((\.|,)?[0-9]+)?$/
	inputAttrs:
		type: 'number'
		step: 'any'

Validation.new class extends Validation
	type: 'alpha'
	regex: /^[A-Za-z \r\n]*$/

Validation.new class extends Validation
	type: 'alphanum'
	regex: /^[A-Za-z0-9 \r\n]*$/

Validation.new class extends Validation
	type: 'phoneint'
	regex: /^[+]*[0-9 \-().]*$/
	inputAttrs:
		type: 'tel'

Validation.new class extends Validation
	type: 'phone10'
	regex: /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/
	inputAttrs:
		type: 'tel'

Validation.new class extends Validation
	type: 'phoneint-ext'
	regex: /^[+]*[0-9 \-().]*?$/

Validation.new class extends Validation
	type: 'phone10-ext'
	regex: /^[0-9]{3}-[0-9]{3}-[0-9]{4}(-[0-9]{1,10})?$/

Validation.new class extends Validation
	type: 'uk-phone-number'
	regex: /^((\+44)?)([ ]?)(0?)([0-9]{2,5})([ ]?)(([0-9]{3,4})?)([ ]?)([0-9]{4,6})$/

Validation.new class extends Validation
	type: 'uk-postal-code'
	regex: /^([A-Z][A-Z]?)(([0-9][0-9]?)|([0-9][A-Z]))[ ][0-9][A-Z][A-Z]$/

Validation.new class extends Validation
	type: 'postal'
	regex: /^([0-9]{1,5}|[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9])$/

Validation.new class extends Validation
	type: 'postal-ca'
	regex: /^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/

Validation.new class extends Validation
	type: 'postal-three-digit'
	regex: /^[A-Za-z][0-9][A-Za-z]$/

Validation.new class extends Validation
	type: 'uniform-resource-locator'
	regex: /^((https?:\/\/)|(HTTPS?:\/\/))?((([A-Za-z0-9\-]+)(\.))+)?([A-Za-z0-9\-])+(\.)([A-Za-z0-9]{2,4})/

Validation.new class extends Validation
	type: 'domain-validation'
	regex: /^((https?:\/\/)|(HTTPS?:\/\/))?((([A-Za-z0-9\-]+)(\.))+)?([A-Za-z0-9\-])+(\.)([A-Za-z0-9]{2,4})$/

Validation.new class extends Validation
	type: 'postal-us'
	regex: /^([0-9]{5})$|^([0-9]{5}-[0-9]{4})$/

Validation.new class extends Validation
	type: 'currency'
	regex: /(^[\$]?\d+((\.|,)?\d{2,})*((\.|,)[0-9]{1,2})?[\$]?$)/
	prefix: '$'

Validation.new class extends Validation
	type: 'percentage-bound'
	regex: /^(([0-9][0-9]?|100)([.,][0-9]*)?\%?)$/
	suffix: '%'

Validation.new class extends Validation
	type: 'percentage-unbound'
	regex: /^(\%)?[0-9]*([.,][0-9]*)?(\%)?$/
	suffix: '%'

Validation.new class extends Validation
	type: 'wordCount'
	regex: /^.*$/m

	validate: (value) ->
		super(value)

		return if not value

		#Validate Value
		[min, max] = [parseInt(@get('minWords', 0), 10), parseInt(@get('maxWords', -1), 10)]
		counted_words = (f for f in value.trim().replace('\r\n',' ').replace('\r',' ').replace('\n',' ').split(' ') when f.trim() != '').length

		if not (min <= counted_words <= max)
			throw new ValidationError "This value must be between #{min} and #{max} words."

Validation.new class extends Validation
	type: 'all'
	regex: /^.*$/

class Variable extends Backbone.Model
	defaults:
		required: no

	type: undefined

	label: -> @get('label')?.toString()
	name: -> @get('name')
	title: -> @get('title')
	rightLabel: -> (@get('rightLabel') ? '').toString()

	escapedId: ->
		### Returns this variable's identifier suitable for use in a jQuery selector. ###
		@id.replace /([\.:])/g, "\\$1"

	exportId: ->
		### Returns the identifier to be used when exporting to tables/CSV. ###
		@get('exportId') ? @id

	toString: -> @get('name') ? @id

	render: (include_error_placeholder=true)-> @template({context: this}, include_error_placeholder)

	getFormValue: (value) -> if value? then [value] else []

	fromFormValue: (value) -> value?[0] ? undefined

	loadForm: (form, value) ->
		### Updates form elements for this variable with the given value. ###
		for x in form.childNodes
			$(":input[name=#{@escapedId()}]", x).val(@getFormValue(value))

	saveForm: (form, values) -> values[@id] = @fromFormValue(form[@id])

	getExportValues: (value) -> [value ? ""]

	fromExportValues: (values) -> values[0] ? undefined

	getPipedValue: (value) -> value ? ""

	needsPiping: () ->
		/\{\{\s*([^\{\}]+)\s*\}\}/g.test(@initialValue ? '')

	getScore: (value) -> 0

	validateResponse: (response) ->
		if @get('required') and (if _.isArray(response.values[@id]) then _.isEmpty(response.values[@id]) else not response.values[@id]?) and not $('[name='+@id+']').closest('.hidden').length
			throw new RequiredError

	@makeList: (idPrefix, namePrefix, info, questionTitle) ->
		for child, i in info
			attrs =
				id: "#{idPrefix}_#{i}"
				title: "#{questionTitle} | #{trans.make child.label}"
				name: "#{namePrefix}.#{i}"
				label: trans.make child.label
				required: child.required
				appearance: switch child.type
					when 'single' then child.choiceAppearance
					when 'dropdown' then 'dropdown'
					else child.appearance
				rows: child.rows
				columns: child.cols
				choices: Choice.makeList child.choices if child.choices?
				validation: child.validation

			new (switch child.type
					when 'checkbox', 'boolean' then BooleanVariable
					when 'string', 'text' then StringVariable
					when 'single', 'dropdown' then SingleChoiceVariable) attrs

class StringVariable extends Variable
	defaults: _.extend(Variable::defaults,
		columns: 20
		rows: 1
		prefix: undefined
		suffix: undefined
		validation: undefined)

	type: 'string'

	rows: -> @get('rows')
	columns: -> @get('columns')

	constructor: (info) ->
		if info.appearance == 'full'
			info.rows ?= 5
			info.columns ?= 50
		else
			info.rows = 1

		if info.validation? and info.validation.type of Validation.TYPES
			info.validation = validation = new Validation.TYPES[info.validation.type] _.extendAttrs {message: trans.make info.validation.errorMsg},
				['minLength', 'maxLength', 'minValue', 'maxValue', 'minWords', 'maxWords'], info.validation

			info.prefix ?= validation.prefix
			info.suffix ?= validation.suffix
		else
			info.validation = undefined

		super(info)

		if info.initialValue
			@initialValue = trans.make info.initialValue

	validateResponse: (response) ->
		if @get('required') and not response.values[@id] and not $('input[name='+@id+'], textarea[name='+@id+']').closest('.hidden').length
			if not @get('choice') or @get('choice').id == response.values[@get('choice').get('variable').id] or response.values[@get('choice').get('variable').id]?.indexOf?(@get('choice').id) > -1
				throw new RequiredError

		if @get('validation')?
			@get('validation').validate(response.values[@id])

	template: CoffeeKup.compile (include_error_placeholder)->
		if include_error_placeholder
			div class: 'error-placeholder', id: "error_#{@id}"
		if @rows() == 1
			div class: "input-wrap #{if @get('prefix') then 'input-prepend' else ''} #{if @get('suffix') then 'input-append' else ''}", ->
				if @get('prefix')
					span class: 'add-on', -> @get('prefix')
				attrs = {id: "id_#{@id}", name: @id, type: 'text', size: @columns(), value: @initialValue, class: 'other' if @get('choice')}
				if @needsPiping()
					attrs['data-needsPiping']= @initialValue.toString().replace /\{\{\s*([^\{\}]+)\s*\}\}/g, '$1'
				input _.extend attrs, (@get('validation')?.inputAttrs)

				if @get('suffix')
					span class: 'add-on', -> @get('suffix')
		else
			textarea id: "id_#{@id}", name: @id, rows: @rows(), cols: @columns(), ->
				text @initialValue if @initialValue

class HiddenVariable extends Variable
	type: 'string'

	constructor: (info) ->
		super(info)
		if info.initialValue
			@initialValue = trans.make info.initialValue

	template: CoffeeKup.compile ->
		attrs = {id: "id_#{@id}", name: @id, type: 'hidden', value: @get('initialValue')}
		if @needsPiping()
			attrs['data-needsPiping']= @initialValue.toString().replace /\{\{\s*([^\{\}]+)\s*\}\}/g, '$1'
		input attrs

class BooleanVariable extends Variable
	defaults:
		appearance: 'default'

	type: 'boolean'

	template: CoffeeKup.compile ->
		div class: 'error-placeholder', id: "error_#{@id}"
		if @get('appearance') in ['radio', 'horizontal', 'slider', 'vertical']
			if @get('appearance') == 'horizontal' then class_value = 'choices horizontal' else class_value = 'choices'
			ul  class:  class_value, ->
				li ->
					input type: 'radio', name: @id, value: '1', id: "id_#{@id}"
					label for: "id_#{@id}", -> (trans.make TRANSLATIONS["strings.Yes"]).toString()
				li ->
					input type: 'radio', name: @id, value: '0', id: "id_#{@id}_on"
					label for: "id_#{@id}_on", -> (trans.make TRANSLATIONS["strings.No"]).toString()
		else
			input type: 'checkbox', name: @id, value: 'on', id: "id_#{@id}"

	getFormValue: (value) ->
		if @get('appearance') in ['radio', 'horizontal']
			if not value? then [] else [if value then '1' else '0']
		else
			if not value then [] else ['on']

	fromFormValue: (value) ->
		if @get('appearance') in ['radio','horizontal']
			if not value?.length then undefined else !!Number(value[0])
		else
			!!value?.length

	getScore: (value) -> if not value? then 0 else if value then 1 else 0

	getExportValues: (value) -> [if not value? then "" else if not value then "False" else "True"]

	fromExportValues: (values) -> if values[0] == "True" then true else if values[0] == "False" then false else undefined

	getPipedValue: (value) ->
		if not value? then "" else if value == "0" or value == true then "Yes" else "No"

	validateResponse: (response) ->
		if @get('required') and @get('appearance') in ['radio','horizontal'] and not response.values[@id]? and not $('input[name='+@id+']').closest('.hidden').length
			throw new RequiredError

	###getScore: (value) ->
		if Boolean value then 1 else 0###

class ChoiceVariable extends Variable
	defaults: _.extend(Variable::defaults,
		randomize: false
		appearance: 'vertical')

	choices: -> @get('choices')

	appearance: -> @get('appearance')

	initialValue: -> @get('initialValue')

	alphabetize: -> @get('alphabetize')

	choicesDisplay: ->
		choices = @choices()

		if @get('randomize')
			fixed = []
			shuffled = []

			for choice, i in choices
				if choice.get('other') or choice.get('na') or choice.get('static')

					fixed.push [i, choice]
				else
					shuffled.push choice

			shuffled = _(shuffled).shuffled()

			for [i, choice] in fixed
				shuffled.splice i, 0, choice

			return shuffled

		if @get('alphabetize')
			sortfunc = (a,b) =>
				if a.label() < b.label()
					return -1
				else
					return 1

			choices = _.toArray(choices);
			choices.sort(sortfunc);

		return choices

	template: CoffeeKup.compile ->
		div class: 'error-placeholder', id: "error_#{@id}"
		if @appearance() == 'dropdown' or @appearance() == 'combo' or @appearance() == 'drilldown'
			attrs = {id: "id_#{@id}", name: @id}
			attrs.size = 5 if @appearance() == 'combo' or @appearance() == 'drilldown'
			attrs.multiple = 'multiple' if @type == 'multi'
			attrs.class = 'drilldown' if @appearance() == 'drilldown'

			select attrs, ->
				if @appearance() == 'dropdown'
					option value: '', -> "---"

				if @get('categories')?
					# NOTE: drilldowns do not support different ids for the
					# choices other than index
					i = 0
					for category in @get('categories')
						optgroup label: category.label(), ->
							for choice in category.get('choices')
								option value: i, -> choice.label()
								i++
				else

					for choice in @choicesDisplay()
						attrs = {}
						if @get('extraction')
							attrs['data-extraction'] = choice.id

						if choice.id == @get('initialValue')
							option selected: 'selected', value: choice.id, attrs, -> choice.label()
						else
							option value: choice.id, attrs, -> choice.label()

		else if @appearance() == 'star'
			div class: 'choices star-container clearfix', ->
				for choice in @choicesDisplay()
					id = "id_#{@id}_#{choice.id}"
					input type: (if @type == 'multi' then 'checkbox' else 'radio'), name: @id, value: choice.id, id: id

		else
			classes = 'choices'
			classes += ' horizontal' if @appearance() == 'horizontal'
			ul class: classes, ->
				for choice in @choicesDisplay()
					attrs = {}
					choiceLabel = choice.label()
					if @get('extraction')
						attrs['data-extraction'] = choice.id
						choiceLabel = @get('extraction').labelForChoice choice.id

					li attrs, ->
						other = if @type == 'multi' then "#{@id}_#{choice.id}_other" else "#{@id}_other"

						if choice.get('other')
							div class: 'error-placeholder', id: "error_#{other}"

						id = "id_#{@id}_#{choice.id}"
						attrs = type: (if @type == 'multi' then 'checkbox' else 'radio'), name: @id, value: choice.id, id: id
						attrs['checked'] = 'checked' if choice.id == @get('initialValue')
						if choice.get('na') and choice.get('check_all')
							attrs['class'] = 'na-choice check-all'
						else if choice.get('na')
							attrs['class'] = 'na-choice'
						else if choice.get('check_all')
							attrs['class'] = 'check-all'

						input attrs

						label for: id, -> Survey.pipe choiceLabel

						if choice.get('other')
							v = choice.get('other')
							text ' '
							html v.render(false)

class SingleChoiceVariable extends ChoiceVariable
	type: 'single'
	inputType: 'radio'

	getFormValue: (value) -> if value? then [value.toString()] else if @appearance() == 'dropdown' then [''] else []

	fromFormValue: (value) -> if value?.length and value[0].length then parseInt(value[0], 10) else undefined

	getExportValues: (value, options) ->
		categories = @get('categories')
		category = undefined
		choice = @choices()[value]
		label = if choice? then choice.label() else ''

		if categories
			i = 0
			for cat in categories
				for ch in cat.get('choices')
					if ch.id == value
						category = cat
						break
				if category?
					break
				i++
			return [String(if category? then category.label() + ': ' + label else label)]
		else if options?.label
			return [String(label)]
		else
			return if value? and choice? then ["#{@getScore(value)}"] else ['']

	fromExportValues: (values) ->
		return undefined if not values[0]?

		categories = @get('categories')

		if categories

			for category in categories
				for choice in category.get('choices')
					if String(category.label() + ': ' + choice.label()) == values[0]
						return choice.id

		else
			for choice in @choices()
				if String(choice.score()) == values[0] or String(choice.label()) == values[0]
					return choice.id

		return undefined

	getScore: (value) ->
		value = parseInt(value, 10) if value?
		choice = @choices()[value]
		return if choice? then choice.score() else undefined

	getPipedValue: (value) ->
		value = parseInt(value, 10) if value?
		choice = @choices()[value]
		return String(if choice? then choice.label() else "")

###	getScore: (value) ->
		debugger
		return 0 unless value?
		choice = @choices()[value]
		return choice.get('score')###

class MultipleChoiceVariable extends ChoiceVariable
	type: 'multi'
	inputType: 'checkbox'

	validateResponse: (response) ->
		super(response)

		if @get('restrictions')
			min = @get('restrictions').minChecked
			max = @get('restrictions').maxChecked
			checked = response.values[@id]?.length
			if checked > max or (checked > 0 and checked < min)
				throw new ValidationError(@get('restrictions').message ? "You must select between #{min} and #{max} choices.")

	getFormValue: (value) -> (el.toString() for el in value ? [])

	fromFormValue: (value) -> (parseInt(el, 10) for el in value ? [])

	getExportValues: (value, opts={}) ->
		for choice in @choices()
			if _.include(value ? [], choice.id)
				if opts.label
					choice.label()
				else
					"1"
			else
				""

	fromExportValues: (values) ->
		result = []

		for choice, i in @choices()
			if values[i] == "1"
				result.push(choice.id)

		return result

	getScore: (value) ->
		scores = (choice.score() for choice in @choices() when _.include(value ? [], choice.id))
		sum = 0
		for score in scores
			sum += score
		return sum

	getPipedValue: (value) ->
		(choice.label() for choice in @choices() when _.include(value ? [], choice.id)).join(", ")


class DateTimeVariable extends Variable
	FORMATS:
		datetime: 'yyyy-MM-dd HH:mm:ss'
		datetimetz: 'yyyy-MM-dd HH:mm:sso'
		date: 'yyyy-MM-dd'
		time: 'HH:mm:ss'
		monthday: "MM/dd"
		yearmonth: "yyyy/MM"

	defaults: _.extend(Variable::defaults,
		format: 'datetime'
		showNowButton: false)

	type: 'datetime'

	validateResponse: (response) ->
		super(response)
		if response.values[@id] and response.values[@id].indexOf("NaN") >= 0
			throw new ValidationError "Please enter the date in the form YYYY/MM/DD"

	getExportValues: (value) ->
		if value?
			value = new _.date(value)
			[value.format(@FORMATS[@get('format')])]
		else
			['']

	fromExportValues: (values) ->
		value = values[0] ? undefined

		return unless value?

		format = @get('format')

		if format in ['datetime', 'datetimetz', 'date']
			value = new _.date(value.replace(' ', 'T'))
		else if format == 'time'
			value = _.date.parseTime value
		else if format == 'monthday'
			value = new _.date(new _.date().getFullYear() + "/" + value)

		return value

	loadForm: (form, value) ->
		format = @get('format')

		if value?
			value = new _.date(value)

			for node in form.childNodes
				if format in ['datetime', 'datetimetz', 'date']
					dateInput = $(":input[name=#{@escapedId()}_date]", node).val([value.format('yyyy/MM/dd')])
				if format in ['datetime', 'datetimetz', 'time']
					timeInput = $(":input[name=#{@escapedId()}_time]", node).val([value.format(if format == 'datetimetz' then 'HH:mm:ss' else 'h:mmtt')])
				if format == "monthday"
					dateInput = $(":input[name=#{@escapedId()}_date]", node).val([value.format('MM/dd')])

	saveForm: (form, values) ->
		format = @get('format')

		date = form["#{@id}_date"]
		time = form["#{@id}_time"]

		value = null

		if format in ['datetime', 'datetimetz', 'date']
			if date?[0]
				value = new _.date(date[0])

		if format in ['datetime', 'datetimetz', 'time']
			if time?[0] and value?
				value.setHMS _.date.parseTime time[0]
			else if time?[0]
				value = _.date.parseTime time[0]

		if format == 'monthday' and date?[0]
			value = new _.date(new _.date().getFullYear() + "/" + date[0])

		values[@id] = value?.format(@FORMATS[format])

	template: CoffeeKup.compile ->
		format = @get('format')

		div class: 'error-placeholder', id: "error_#{@id}"

		attrs = if @get('showNowButton') then readonly: true else {}

		if format in ['datetime', 'datetimetz', 'date']
			input id: "id_#{@id}_date", name: "#{@id}_date", type: 'text', class: 'date', placeholder: "YYYY/MM/DD", attrs

		if format in ['datetime', 'datetimetz', 'time']
			input id: "id_#{@id}_time", name: "#{@id}_time", type: 'text', class: 'time', placeholder: "HH:MM", attrs

		if format == 'monthday'
			input id: "id_#{@id}_date", name: "#{@id}_date", type: 'text', class: 'month-day', placeholder: "MM/DD", attrs

		if @get('showNowButton')
			a class: 'button datetime-now', href: '#', -> "Record Now"

module.exports =
	StringVariable: StringVariable
	SingleChoiceVariable: SingleChoiceVariable
	MultipleChoiceVariable: MultipleChoiceVariable
	DateTimeVariable: DateTimeVariable
	BooleanVariable: BooleanVariable
	HiddenVariable: HiddenVariable
	Variable: Variable
